import React from 'react';
import styled from 'styled-components';
import { colors } from '_styles';

const RadioElement = styled.input`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: none;
  border: 0;
  border: 1px solid #A0A0A0;
  appearance: none;
  transition: box-shadow 0 cubic-bezier(.95,.15,.5,1.25);
  pointer-events: none;

  .hasLabel {
    float: left;
    margin-right: 15px;
  }

  &:focus {
    outline: none
  }

  &:checked {
    background: ${colors.RC_ACTION};
    box-shadow:
    inset 0 3px 0 white, /* Top */
    inset -3px 0 0 white, /* Right */
    inset 0 -3px 0 white, /* Bottom */
    inset 3px 0 0 white, /* Left */
    inset -2px 2px 0 white, /* Top Right */
    inset -2px -2px 0 white, /* Bottom Right */
    inset 2px -2px 0 white, /* Bottom Left */
    inset 2px 2px 0 white; /* Top Left */
  }

  &:disabled {
    background: #A0A0A0;
    box-shadow:
    inset 0 3px 0 white, /* Top */
    inset -3px 0 0 white, /* Right */
    inset 0 -3px 0 white, /* Bottom */
    inset 3px 0 0 white, /* Left */
    inset -2px 2px 0 white, /* Top Right */
    inset -2px -2px 0 white, /* Bottom Right */
    inset 2px -2px 0 white, /* Bottom Left */
    inset 2px 2px 0 white; /* Top Left */
  }
`;

const Label = styled.label`
  display: block;
  position: relative;
  margin: 15px 0;
  min-height: 26px;
  line-height: 26px;
  font-size: 16px !important;
   
`;

const RadioTextLabel = styled.span`
  display: inline;

  &.disabled {
    color: #A0A0A0;
  }
`;

const WithLabel = ({
  value,
  label,
  selected,
  disabled,
  className,
  radioRef,
  ...props
}) => (
  <Label>
    <RadioElement
      ref={radioRef}
      type="radio"
      value={value}
      disabled={disabled}
      className={`${className} hasLabel`}
      aria-label="select one of the options"
      {...props}
    />
    {
      label ? (
        <RadioTextLabel
          className={disabled ? 'disabled' : ''}
        >
          {label}
        </RadioTextLabel>
      ) : null
    }
  </Label>
);

const InputOnly = ({
  value,
  label,
  selected,
  disabled,
  radioRef,
  ...props
}) => (
  <RadioElement
    ref={radioRef}
    type="radio"
    value={value}
    disabled={disabled}
    {...props}
  />
);

const Radio = ({
  value,
  label,
  selected,
  radioRef,
  ...props
}) => (
  <>
    {
      label ? (
        <WithLabel
          value={value}
          label={label}
          selected={selected}
          radioRef={radioRef}
          {...props}
        />
      ) : (
        <InputOnly
          value={value}
          selected={selected}
          radioRef={radioRef}
          {...props}
        />
      )
    }
  </>
);

export default Radio;
